export function Visibility ({ visible, children }) {
  return visible ? children : null
}
